import { graphql } from "../generated/gql";

export const DeleteNote = graphql(`
  mutation DeleteNote($noteId: ID!) {
    deleteNote(noteId: $noteId) {
      id
    }
  }
`);
